import useBreakpoint from './useBreakpoint'

const useSignatureSize = (maxWidth: number, padding: number) => {
  const size = useBreakpoint()

  const baseWidth = size.width - padding
  const width = baseWidth > maxWidth ? maxWidth : baseWidth
  const height = width / 2

  return { width, height }
}

export default useSignatureSize
